import { ThemeUICSSObject, getColorsByPath, responsive } from '@apia/theme';
/* IMPORT HERE */

const primary: ThemeUICSSObject = {
  variant: 'layout.common.components.accordion.default',
  '& > button': {
    variant: 'buttons.accordion-primary',
    '*': {
      color: 'palette.primary.contrastText',
    },
  },
  '.twoColumns__main__bodyAside.accordionElement': {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
  },
  ...getColorsByPath('accordion'),
  '.substitutionList': {
    gridColumnStart: 1,
    gridColumnEnd: responsive({
      0: 2,
      2: 3,
      4: 5,
    }),
  },
  '.content': {
    borderBottom: 'none',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
  },
  /* PREPEND HERE */
};

export default primary;
